import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { darken, lighten, transitions } from 'polished';
import colors from '../utilities/colors';

const ButtonWrapper = styled.div`
    a, button {
        border: none;
        display: inline-block;
        text-align: center;
        text-decoration: none;
        color: ${colors.white};
        padding: 10px 20px;
        font-weight: bold;
        font-size: 15px;
        cursor: pointer;
        
        ${transitions('all 0.2s ease-in 0s')};
    
        &.btn-primary {
            background: ${colors.primary};
            &:hover, &:focus, &:active {
                background: ${darken(0.15, colors.primary)};
            }
        }
        
        &.btn-secondary {
            background: ${colors.black};
            &:hover, &:focus, &:active {
                background: ${lighten(0.15, colors.black)};
            }
        }
        
        &.btn-outline {
          background: transparent;
          border: 1px solid ${colors.primary};
          color: ${colors.primary};
          padding: 7px 10px;
          font-weight: normal;
          &:hover, &:focus, &:active {
            background: ${colors.primary};
            color: ${colors.white}
          }
        }
        
        &.btn-link {
          text-decoration: underline;
          padding: 5px;
          background: transparent;
          color: ${colors.black};
          font-weight: normal;
          &:hover, &:focus, &:active {
            color: ${colors.primary};
          }
        }
        
        &.btn-block {
            display: block;
            width: 100%;
        }
    }
`;

const Button = (props) => {
    const CustomTag = props.tag;
    const href = props.href ? props.href : null;

    return (
        <ButtonWrapper>
            <CustomTag target={'_blank'} href={href} className={'btn ' + props.class} onClick={props.onClick}>{props.label}</CustomTag>
        </ButtonWrapper>
    );
};

Button.propTypes = {
    label: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    class: PropTypes.string,
    href: PropTypes.string,
};

export default Button;
